// extracted by mini-css-extract-plugin
export default {"app_logout":"logout_app_logout__ZjBzs"};